import { useFlag } from '@unleash/proxy-client-react'

import { FLAG_DISABLE_DEPRECATED_FEATURES } from '../constants/flags.constants'

/**
 * When enabled, the deprecated areas of the app (Analytics, Brand Collabs,
 * Personal Settings) are removed together with the whole sidebar navigation,
 * and their routes redirect to My Page.
 */
export const useIsDeprecatedFeaturesDisabled = (): boolean =>
  useFlag(FLAG_DISABLE_DEPRECATED_FEATURES)
